module.exports = __webpack_public_path__ + "assets/img/6c87586f3379a0917522754bec13c2f9.svg";